import emptry from "@/views/mobileViews/components/emptry.vue";
export default [
  {
    path: "/",
    name: "Index",
    component: () => import("../views/mobileViews/HomeIndex.vue"), //主页
    redirect: "/index/homePage",
  },
  {
    path: "/index",
    name: "HomeIndex",
    component: () => import("../views/mobileViews/HomeIndex.vue"), // 主页
    redirect: "/index/homePage",
    children: [
      {
        path: "/index/homePage",
        name: "homePage",
        component: () => import("../views/mobileViews/views/homePage.vue"), // 首页
      },
      {
        path: "/index/interviewAndStory",
        name: "interviewAndStory",
        component: () =>
          import("../views/mobileViews/views/interviewAndStory.vue"), // 采访与故事             // 采访与故事
        meta: { title: "采访与故事" },
        redirect: "/index/interviewAndStory/index",
        children: [
          {
            path: "/index/interviewAndStory/index",
            name: "interviewAndStory-index",
            component: () =>
              import("../views/mobileViews/views/interviewAndStory/index.vue"), // 采访与故事
            meta: { title: "采访与故事" },
          },
          {
            path: "/index/interviewAndStory/memberList",
            name: "interviewMembers",
            component: () =>
              import(
                "../views/mobileViews/views/interviewAndStory/memberList.vue"
              ), // 采访与故事
            meta: { title: "采访与故事" },
          },
          {
            path: "/index/interviewAndStory/memberDetail",
            name: "interviewMemberDetail",
            component: () =>
              import(
                "../views/mobileViews/views/interviewAndStory/memberDetail.vue"
              ), // 采访与故事
            meta: { title: "采访与故事" },
          },
          {
            path: "/index/interviewAndStory/foundingStory",
            name: "foundingStory",
            component: () =>
              import(
                "../views/mobileViews/views/interviewAndStory/foundingStory.vue"
              ), // 采访与故事
            meta: { title: "采访与故事" },
          },
        ],
      },
      {
        path: "/index/scientificBreakthrough",
        name: "scientificBreakthrough",
        component: () =>
          import("../views/mobileViews/views/scientificBreakthrough.vue"),
        meta: { title: "科学突破" },
        redirect: "/index/scientificBreakthrough/scientificBreakthroughList",
        children: [
          {
            path: "/index/scientificBreakthrough/scientificBreakthroughList",
            name: "scientificBreakthroughList",
            component: () =>
              import(
                "../views/mobileViews/views/scientificBreakthrough/scientificBreakthroughList.vue"
              ),
          },
          {
            path: "/index/scientificBreakthrough/scientificBreakthroughDetail",
            name: "scientificBreakthroughDetail",
            component: () =>
              import(
                "../views/mobileViews/views/scientificBreakthrough/scientificBreakthroughDetail.vue"
              ),
          },
          {
            path: "/index/scientificBreakthrough/scientificBreakthroughMore",
            name: "scientificBreakthroughMore",
            component: () =>
              import(
                "../views/mobileViews/views/scientificBreakthrough/scientificBreakthroughMore.vue"
              ),
          },
        ],
      },
      {
        path: "/index/translationalMedicine",
        name: "translationalMedicine",
        component: () =>
          import("../views/mobileViews/views/translationalMedicine.vue"), // 转化医学
        meta: { title: "转化医学" },
        redirect:
          "/index/translationalMedicine/translationalMedicineDefinition",
        children: [
          {
            path: "/index/translationalMedicine/translationalMedicineDefinition",
            name: "translationalMedicineDefinition",
            component: () =>
              import(
                "../views/mobileViews/views/translationalMedicine/translationalMedicineDefinition.vue"
              ),
          },
          {
            path: "/index/translationalMedicine/deviceApproval",
            name: "deviceApproval",
            component: () =>
              import(
                "../views/mobileViews/views/translationalMedicine/deviceApproval.vue"
              ),
          },
          {
            path: "/index/translationalMedicine/drugApproval",
            name: "drugApproval",
            component: () =>
              import(
                "../views/mobileViews/views/translationalMedicine/drugApproval.vue"
              ),
          },
          {
            path: "/index/translationalMedicine/innovativeDrugNews",
            name: "innovativeDrugNews",
            component: () =>
              import(
                "../views/mobileViews/views/translationalMedicine/innovativeDrugNews.vue"
              ),
          },
          {
            path: "/index/translationalMedicine/innovativeDrugNewsDeatil",
            name: "innovativeDrugNewsDeatil",
            component: () =>
              import(
                "../views/mobileViews/views/translationalMedicine/innovativeDrugNewsDeatil.vue"
              ),
          },
          {
            path: "/index/translationalMedicine/generalBiologicsGuidances",
            name: "generalBiologicsGuidances",
            component: () =>
              import(
                "../views/mobileViews/views/translationalMedicine/generalBiologicsGuidances.vue"
              ),
          },
          {
            path: "/index/translationalMedicine/generalBiologicsGuidancesDetail",
            name: "generalBiologicsGuidancesDetail",
            component: () =>
              import(
                "../views/mobileViews/views/translationalMedicine/generalBiologicsGuidancesDetail.vue"
              ),
          },
          {
            path: "/index/translationalMedicine/medicalDevicesGuidance",
            name: "medicalDevicesGuidances",
            component: () =>
              import(
                "../views/mobileViews/views/translationalMedicine/medicalDevicesGuidance.vue"
              ),
          },
          {
            path: "/index/translationalMedicine/medicalDevicesGuidanceDetail",
            name: "medicalDevicesGuidanceDetail",
            component: () =>
              import(
                "../views/mobileViews/views/translationalMedicine/medicalDevicesGuidanceDetail.vue"
              ),
          },
        ],
      },
      {
        path: "/index/professionalsMembership",
        name: "professionalsMembership",
        component: () =>
          import("../views/mobileViews/views/professionalsMembership.vue"), //专业社群
        meta: { title: "专业社群" },
        redirect: "/index/professionalsMembership/index",
        children: [
          {
            path: "/index/professionalsMembership/index",
            name: "professionalsMembership-index",
            component: () =>
              import(
                "../views/mobileViews/views/ProfessionalsMembership/index.vue"
              ),
            meta: { title: "专业社群" },
          },
          {
            path: "/index/professionalsMembership/community",
            name: "professionalsMembershipCommunity",
            component: () =>
              import(
                "../views/mobileViews/views/ProfessionalsMembership/community/community.vue"
              ),
            meta: { title: "专业社群-社区" },
          },
          {
            path: "/index/professionalsMembership/communityDeep",
            name: "professionalsMembershipCommunityDeep",
            component: () =>
              import(
                "../views/mobileViews/views/ProfessionalsMembership/community/communityDeep.vue"
              ),
            meta: { title: "专业社群-社区" },
          },
          {
            path: "/index/professionalsMembership/articelDetail",
            name: "professionalsMembershipArticelDetail",
            component: () =>
              import(
                "../views/mobileViews/views/ProfessionalsMembership/community/articelDetail.vue"
              ),
            meta: { title: "专业社群-社区" },
          },
          {
            path: "/index/professionalsMembership/guid",
            name: "professionalsMembershipGuid",
            component: () =>
              import(
                "../views/mobileViews/views/ProfessionalsMembership/guid.vue"
              ),
            meta: { title: "专业社群-指南与声明" },
          },
          {
            path: "/index/professionalsMembership/fakerGuid",
            name: "professionalsMembershipFakerGuid",
            component: () =>
              import(
                "../views/mobileViews/views/ProfessionalsMembership/mklGuid/fakerGuid.vue"
              ),
            meta: { title: "专业社群-指南" },
          },
          {
            path: "/index/professionalsMembership/ScienceNews",
            name: "professionalsMembershipScienceNews",
            component: () =>
              import(
                "../views/mobileViews/views/ProfessionalsMembership/ScienceNews.vue"
              ),
            meta: { title: "专业社群-科学指南" },
          },
          {
            path: "/index/professionalsMembership/FeaturedJournals",
            name: "professionalsMembershipFeaturedJournals",
            component: () =>
              import(
                "../views/mobileViews/views/ProfessionalsMembership/FeaturedJournals.vue"
              ),
            meta: { title: "专业社群-特色期刊" },
          },
          {
            path: "/index/professionalsMembership/Education",
            name: "professionalsMembershipEducation",
            component: () =>
              import(
                "../views/mobileViews/views/ProfessionalsMembership/education/list.vue"
              ),
            meta: { title: "专业社群-教育" },
          },
          {
            path: "/index/professionalsMembership/EducationDetail",
            name: "professionalsMembershipEducationDetail",
            component: () =>
              import(
                "../views/mobileViews/views/ProfessionalsMembership/education/detail.vue"
              ),
            meta: { title: "专业社群-教育" },
          },
        ],
      },
      {
        path: "/index/getInvolved",
        name: "getInvolved",
        component: () => import("../views/mobileViews/views/getInvolved.vue"), //专业社群
        meta: { title: "合作参与" },
        redirect: "/index/getInvolved/index",
        children: [
          {
            path: "/index/getInvolved/index",
            name: "getInvolved-index",
            component: () =>
              import("../views/mobileViews/views/getInvolved/index.vue"),
            meta: { title: "合作参与" },
          },
          {
            path: "/index/getInvolved/advocate",
            name: "getInvolvedAdvocate",
            component: () =>
              import("../views/mobileViews/views/getInvolved/advocate.vue"),
            meta: { title: "合作参与-倡导" },
          },
          {
            path: "/index/getInvolved/donate",
            name: "getInvolvedDonate",
            component: () =>
              import("../views/mobileViews/views/getInvolved/donate.vue"),
            meta: { title: "合作参与-捐赠" },
          },
          {
            path: "/index/getInvolved/volunteer",
            name: "getInvolvedVolunteer",
            component: () =>
              import("../views/mobileViews/views/getInvolved/volunteer.vue"),
            meta: { title: "合作参与-志愿者" },
          },
          {
            path: "/index/getInvolved/volunteerDetail",
            name: "getInvolvedVolunteerDetail",
            component: () =>
              import(
                "../views/mobileViews/views/getInvolved/volunteerDetail.vue"
              ),
            meta: { title: "合作参与-志愿者详情" },
          },
          {
            path: "/index/getInvolved/donate/PlannedGiving",
            name: "getInvolvedPlannedGiving",
            component: () =>
              import(
                "../views/mobileViews/views/getInvolved/donate/plannedGiving.vue"
              ),
            meta: { title: "合作参与-捐赠-填写信息" },
          },
          {
            path: "/index/getInvolved/donate/bydPage",
            name: "getInvolvedBydpage",
            component: () =>
              import(
                "../views/mobileViews/views/getInvolved/donate/bydPage.vue"
              ),
            meta: { title: "合作参与-捐赠-填写" },
          },
        ],
      },
      {
        path: "/index/scientificMeetings",
        name: "scientificMeetings",
        component: () =>
          import("../views/mobileViews/views/scientificMeetings.vue"),
        meta: { title: "科学会议" },
        redirect: "/index/scientificMeetings/scientificMeetingsList",
        children: [
          {
            path: "/index/scientificMeetings/scientificMeetingsList",
            name: "scientificMeetingsList",
            component: () =>
              import(
                "../views/mobileViews/views/scientificMeetings/scientificMeetingsList.vue"
              ),
          },
          {
            path: "/index/scientificMeetings/scientificMeetingsDetail",
            name: "scientificMeetingsDetail",
            component: () =>
              import(
                "../views/mobileViews/views/scientificMeetings/scientificMeetingsDetail.vue"
              ),
          },
        ],
      },
      {
        path: "/index/journals",
        name: "journals",
        // component: () => import("../views/webViews/views/journals.vue"), // 期刊
        component: emptry,
        redirect: "/index/journals/introduction",
        meta: { title: "期刊" },
        children: [
          {
            path: "/index/journals/introduction",
            name: "journalsIntroduction",
            component: () =>
              import("../views/mobileViews/views/journals/introduction.vue"), // 期刊
            meta: { title: "期刊" },
          },
          {
            path: "/index/journals/journalDetail",
            name: "journalDetail",
            component: () =>
              import("../views/mobileViews/views/journals/journalDetail.vue"), // 期刊
            meta: { title: "期刊" },
          },
        ],
      },
      {
        path: "/index/aboutUs",
        name: "aboutUs",
        component: () => import("../views/mobileViews/views/aboutUs.vue"), // 关于我们
        meta: { title: "关于我们" },
        redirect: "/index/aboutUs/index",
        children: [
          {
            path: "/index/aboutUs/index",
            name: "aboutUs-index",
            component: () =>
              import("../views/mobileViews/views/aboutUs/index.vue"),
            meta: { title: "关于我们" },
          },
          {
            path: "/index/aboutUs/aboutISITM",
            name: "aboutISITM",
            component: () =>
              import("../views/mobileViews/views/aboutUs/aboutISITM.vue"), // 公司介绍
            meta: { title: "关于我们" },
          },
          {
            path: "/index/aboutUs/annualReport",
            name: "annualReport",
            component: () =>
              import("../views/mobileViews/views/aboutUs/annualReport.vue"), // 发展历程
            meta: { title: "关于我们" },
          },
          {
            path: "/index/aboutUs/executiveTeam",
            name: "executiveTeam",
            component: () =>
              import("../views/mobileViews/views/aboutUs/executiveTeam.vue"), // 执行团队
            meta: { title: "关于我们" },
          },
          {
            path: "/index/aboutUs/executiveTeamDetail",
            name: "executiveTeamDetail",
            component: () =>
              import(
                "../views/mobileViews/views/aboutUs/executiveTeamDetail.vue"
              ), // 执行团队
            meta: { title: "关于我们" },
          },
          {
            path: "/index/aboutUs/newsRoom",
            name: "newsRoom",
            component: () =>
              import("../views/mobileViews/views/aboutUs/newsRoom.vue"), // 执行团队
            meta: { title: "关于我们" },
          },
          {
            path: "/index/aboutUs/mediaNewsroomDetail",
            name: "mediaNewsroomDetail",
            component: () =>
              import("../views/mobileViews/views/aboutUs/mediaNewsroomDetail.vue"), // ISITM媒体新闻详情
            meta: { title: "关于我们" },
          },
          {
            path: "/index/aboutUs/becomeMember",
            name: "becomeMember",
            component: () =>
              import(
                "../views/mobileViews/views/aboutUs/becomeMember/index.vue"
              ), // 成为会员
            meta: { title: "成为会员" },
          },
          {
            path: "/index/personalCenter",
            name: "personalCenter",
            component: () =>
              import("../views/mobileViews/views/personalCenter/index.vue"), // 个人中心
            meta: { title: "个人中心" },
          },
        ],
      },
      {
        path: "/index/globalSearch",
        name: "globalSearch",
        component: () => import("../views/mobileViews/views/globalSearch.vue"), // 搜索
        meta: { title: "搜索" },
        redirect: "/index/globalSearch/globalSearchHome",
        children: [
          {
            path: "/index/globalSearch/globalSearchHome",
            name: "globalSearchHome",
            component: () =>
              import(
                "../views/mobileViews/views/globalSearch/globalSearchHome.vue"
              ), // 搜索
            meta: { title: "搜索" },
          },
        ],
      },
    ],
  },
  {
    path: "/homeUser",
    name: "homeUser",
    component: () => import("../views/mobileViews/views/Home/index.vue"), // 联系我们
    meta: { title: "登录注册" },
  },
];
